import { render, staticRenderFns } from "./editBranchModal.vue?vue&type=template&id=71d5b548&scoped=true&"
import script from "./editBranchModal.vue?vue&type=script&lang=js&"
export * from "./editBranchModal.vue?vue&type=script&lang=js&"
import style0 from "./editBranchModal.vue?vue&type=style&index=0&id=71d5b548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5b548",
  null
  
)

export default component.exports